import React from "react";
import Search from "@material-ui/icons/Search";
import Clear from "@material-ui/icons/Clear";
import localization from "../../../config/localization";

const HomeSearchInput = ({onSearch, value, placeholder="searchbar.input", onKeyPress = () => null, styles = {}, onClear=false }) => {
  return (
  <div className="smart-search-category-searchbar" style={styles}>
    {/*<Search style={{position: "absolute", top:5, left: 12, color: "#6d6d6d"}}/>*/}
    <input
      autoComplete={false}
      placeholder={localization.get(placeholder)}
      value={value}
      onKeyPress={onKeyPress}
      onChange={e => onSearch(e.target.value)}
    />
    {onClear && value && value.length > 0 &&
      <Clear onClick={() => {
        onSearch("")
        onClear()
      }} style={{position: "absolute", width:12, top:7, right: 12, color: "#6d6d6d"}}/>
    }
  </div>)

}

export default HomeSearchInput;
